import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function SolicitarRecuperacion() {
    const [email, setEmail] = useState('');
    const [mensaje, setMensaje] = useState({ texto: '', tipo: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMensaje({ texto: 'Procesando...', tipo: 'info' });

        try {
            // --- MODIFICADO ---
            const response = await fetch('/api/solicitar-recuperacion', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Algo salió mal.');
            }

            setMensaje({ texto: `✅ ${data.message}`, tipo: 'exito' });
            setEmail('');

        } catch (error) {
            setMensaje({ texto: `❌ ${error.message}`, tipo: 'error' });
        }
    };

    const getAlertClass = () => {
        if (mensaje.tipo === 'exito') return 'alert-success';
        if (mensaje.tipo === 'error') return 'alert-danger';
        return 'alert-info';
    };

    return (
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <div className="card shadow p-4 text-center" style={{ width: '100%', maxWidth: '500px' }}>
                <h2>Recuperar Contraseña</h2>
                <p className="text-muted">Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.</p>
                <form onSubmit={handleSubmit} className="mt-3">
                    <div className="mb-3">
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Tu correo electrónico"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary w-100">Enviar Enlace</button>
                </form>
                {mensaje.texto && (
                    <div className={`alert ${getAlertClass()} mt-3`}>
                        {mensaje.texto}
                    </div>
                )}
                <div className="mt-3">
                    <Link to="/login">Volver a Iniciar Sesión</Link>
                </div>
            </div>
        </div>
    );
}

export default SolicitarRecuperacion;